import AuthorCard from './_AuthorCard';
import RecipeCard from './_RecipeCard';
import StoryCard from './_StoryCard';
import CalloutGridCard from '@repo/ui/src/primitives/CalloutGridCard';
import { classNames } from '@repo/ui/src/utils/classNames';
import {
  AuthorProps,
  MediaType,
  ImageProps,
  MetaProps,
  RecipeMetaSectionProps,
  ToutContentProps,
  YoutubeLinkProps,
} from '@repo/ui/src/types';

interface CascadingCardProps {
  _testID: string;
  card: {
    avatar?: MediaType;
    featuredQuote?: string;
    id?: string;
    name?: string;
    author?: AuthorProps;
    assets?: Array<{
      endpoint: string;
      name: string;
    }>;
    toutContent: ToutContentProps;
    linkLabel?: string;
    recipeMetaSection?: RecipeMetaSectionProps;
    _meta: MetaProps;
    actionText?: string;
    categories?: any;
    description?: string;
    fullWidth?: boolean;
    image: ImageProps;
    title?: string;
    youtubeLink?: YoutubeLinkProps;
  };
  className: string;
  i: number;
  staticContent?: {
    author: {
      heading: string;
      link: string;
    };
    story: {
      heading: string;
      link: string;
      playButtonLabel: string;
    };
    recipe: {
      by: string;
      cookTimeLabel: string;
      effort: string;
      heading: string;
      link: string;
      prepTimeLabel: string;
    };
  };
}

const CascadingCard = ({ card, i, staticContent, className, _testID }: CascadingCardProps) => {
  const alignRight = i % 2 !== 0;

  if (!card?._meta) return null;

  const getSchemaType = (schema: string) => {
    const parts = schema.split('/');
    return parts[parts.length - 1] || '';
  };

  const schemaType = getSchemaType(card._meta.schema);

  const getCard = () => {
    switch (schemaType) {
      case 'author.json':
        return <AuthorCard {...card} {...staticContent?.author} />;
      case 'story.json':
        return <StoryCard {...card} {...staticContent?.story} />;
      case 'recipe.json':
        return <RecipeCard {...card} {...staticContent?.recipe} />;
      case 'calloutGridCard.json':
        return <CalloutGridCard {...card} _testID={_testID} />;
      default:
        return null;
    }
  };

  return (
    <div
      className={classNames(
        'relative z-[1] bg-warm-200 text-left min-h-[40vw] mb-4',
        'md:w-[80%] md:max-w-[1280px] md:mb-[-3.2vw] [&>*]:min-h-[inherit]',
        'xl:min-h-[720px] xl:h-[720px] last:mb-0',
        alignRight ? 'ml-auto mr-0' : 'ml-0 mr-auto',
        className,
      )}
    >
      {getCard()}
    </div>
  );
};

export default CascadingCard;
